import p from "./ghl-ui.es1646.js";
import a from "./ghl-ui.es1647.js";
import l from "./ghl-ui.es1648.js";
import s from "./ghl-ui.es1649.js";
import m from "./ghl-ui.es1650.js";
function t(o) {
  var e = -1, h = o == null ? 0 : o.length;
  for (this.clear(); ++e < h; ) {
    var r = o[e];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = l;
t.prototype.has = s;
t.prototype.set = m;
export {
  t as default
};
